import SidebarContext from 'state/SidebarContext';
import { useContext } from 'react';

type ContentProps = {
    priceText: string | undefined;
    tradeTypeText: string;
};

const Content = ({ priceText, tradeTypeText }: ContentProps) => {
    if (!priceText) {
        return <h2 className="mb-14 m-0">{tradeTypeText}</h2>;
    }
    return (
        <div className="mb-14">
            <h2 className="m-0 text-12 text-gray-500">{tradeTypeText}</h2>
            <p className="m-0 h2">{priceText}</p>
        </div>
    );
};

const ContactButton = () => {
    const { uiText } = useContext(SidebarContext);
    const { priceText, tradeTypeText } = uiText.sections.sidebar.notOptedIn;

    return (
        <div className="md:border rounded-8 border-bluegray-200 md:p-16 mb-24">
            <Content priceText={priceText} tradeTypeText={tradeTypeText} />
            <finn-contact-button></finn-contact-button>
        </div>
    );
};

export default ContactButton;
